import type { RouteRecordRaw } from 'vue-router'

const AuthLayout = () => import('@/layouts/AuthLayout.vue')

/**
 * Shared routes: /login, /forgot-password, /reset-password, /callback, /403, /404, /profile,
 * /notifications and the root redirect.
 */
export const authRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    component: AuthLayout,
    children: [
      {
        path: '',
        name: 'login',
        component: () => import('@/app/views/LoginView.vue'),
        meta: { titleKey: 'auth.signIn' },
      },
    ],
  },
  {
    path: '/forgot-password',
    component: AuthLayout,
    children: [
      {
        path: '',
        name: 'forgotPassword',
        component: () => import('@/app/views/ForgotPasswordView.vue'),
        meta: { titleKey: 'auth.forgot.title' },
      },
    ],
  },
  {
    // target of the emailed link: /reset-password?token=…
    path: '/reset-password',
    component: AuthLayout,
    children: [
      {
        path: '',
        name: 'resetPassword',
        component: () => import('@/app/views/ResetPasswordView.vue'),
        meta: { titleKey: 'auth.reset.title' },
      },
    ],
  },
  {
    path: '/callback',
    name: 'callback',
    component: () => import('@/app/views/CallbackView.vue'),
    meta: { titleKey: 'auth.signingIn' },
  },
  {
    path: '/',
    component: () => import('@/layouts/WorkspaceLayout.vue'),
    meta: { requiresAuth: true, allowBeforeActivation: true },
    children: [
      // resolved by the guards to the user's workspace home or onboarding
      { path: '', name: 'home', component: { render: () => null } },
      {
        path: 'profile',
        name: 'profile',
        component: () => import('@/app/views/ProfileView.vue'),
        meta: { titleKey: 'menu.profile' },
      },
      {
        path: 'notifications',
        name: 'notifications',
        component: () => import('@/app/views/NotificationsView.vue'),
        meta: { titleKey: 'menu.notifications' },
      },
    ],
  },
  {
    path: '/403',
    name: 'forbidden',
    component: () => import('@/app/views/ForbiddenView.vue'),
    meta: { titleKey: 'errors.forbidden.title' },
  },
  {
    path: '/404',
    name: 'notFound',
    component: () => import('@/app/views/NotFoundView.vue'),
    meta: { titleKey: 'errors.notFound.title' },
  },
  { path: '/:pathMatch(.*)*', redirect: { name: 'notFound' } },
]
